import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChange, handleRedirectResult } from '@/services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [authError, setAuthError] = useState(null);

  // On Capacitor the Google sign-in uses a redirect flow.
  // Pick up the result when the app reloads after the redirect.
  useEffect(() => {
    handleRedirectResult().catch((err) => {
      if (err?.code === 'ACCESS_DENIED') setAuthError(err.message);
    });
  }, []);

  useEffect(() => {
    const unsub = onAuthStateChange((u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const value = { user, loading, authError, setAuthError };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

/** Hook to access auth context */
export function useAuthContext() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuthContext must be used inside <AuthProvider>');
  return ctx;
}
